var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8817 20.8755H7.91924C4.93049 20.8755 2.93799 19.3811 2.93799 15.8942L2.93799 8.92046C2.93799 5.43358 4.93049 3.93921 7.91924 3.93921L17.8817 3.93921C20.8705 3.93921 22.863 5.43358 22.863 8.92046V15.8942C22.863 19.3811 20.8705 20.8755 17.8817 20.8755Z",
    stroke: "#000",
    strokeWidth: 1.49438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8819 9.41846L14.7637 11.9091C13.7375 12.726 12.0539 12.726 11.0277 11.9091L7.91943 9.41846",
    stroke: "#000",
    strokeWidth: 1.49438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.60a2c8331759075fe772596ee72bf1c9.svg";
export { ForwardRef as ReactComponent };